// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","back_button":"Header_back_button__DFEYc","primary":"Header_primary__HtN9F","secondary":"Header_secondary__qK+YH"};